import React, { useState } from 'react';

interface ILineStyleProps {
	onClick: (weight: number, pattern: string) => void
	linePattern?: string
	lineWidth?: number
}

export const LineStyle: React.FunctionComponent<ILineStyleProps> = ({ onClick, linePattern, lineWidth }) => {
	const [menuOpen, setMenuOpen] = useState(false)

	const lineSelectClickHandler = (e: React.MouseEvent<any>) => {
		setMenuOpen(o => !o);
	}
	let cName;
	if (linePattern && lineWidth) {
		cName = 'ciq-' + linePattern + '-' + lineWidth;
	}

	const menuDisplay = {
		display: menuOpen ? 'block' : 'none',
	};

	const menuOptionClickHandler = (e: React.MouseEvent<any>) => {
		const { width, pattern } = e.currentTarget.dataset
		onClick(width, pattern)
	}

	if (cName) {
		return (
			<span>
				<menu-select id="lineSelect" onClick={lineSelectClickHandler}>
					<span className={'title ' + cName} />
					<menu-select-options className="menu-hover" style={menuDisplay}>
						<menu-option class="option" data-width="1" data-pattern="solid" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-solid-1" /></menu-option>
						<menu-option class="option" data-width="3" data-pattern="solid" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-solid-3" /></menu-option>
						<menu-option class="option" data-width="5" data-pattern="solid" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-solid-5" /></menu-option>
						<menu-option class="option" data-width="1" data-pattern="dotted" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dotted-1" /></menu-option>
						<menu-option class="option" data-width="3" data-pattern="dotted" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dotted-3" /></menu-option>
						<menu-option class="option" data-width="5" data-pattern="dotted" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dotted-5" /></menu-option>
						<menu-option class="option" data-width="1" data-pattern="dashed" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dashed-1" /></menu-option>
						<menu-option class="option" data-width="3" data-pattern="dashed" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dashed-3" /></menu-option>
						<menu-option class="option" data-width="5" data-pattern="dashed" onClick={menuOptionClickHandler}><span className="ciq-line-style-option ciq-dashed-5" /></menu-option>
					</menu-select-options>
				</menu-select>
			</span>
		);
	}
	return <span />;
}